import { render, staticRenderFns } from "./PromotionPreviewDetails.vue?vue&type=template&id=473a4fb3"
import script from "./PromotionPreviewDetails.vue?vue&type=script&lang=js"
export * from "./PromotionPreviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports